import client from '../utils/client'
import { gql } from '@apollo/client'

import { EditableCompanyField } from '../utils/company'
import { MutationHandlerResult } from '../utils/errors'

const UPSERT_COMPANY = gql`
	mutation UpsertCompany($restaurantId: ID!, $input: UpsertCompanyInput!) {
		upsertCompany(restaurantId: $restaurantId, input: $input) {
			success
		}
	}
`

const upsertCompany = async ({
	restaurantId,
	input,
}: {
	restaurantId: string
	input: Partial<Record<EditableCompanyField, string | null>>
}): Promise<MutationHandlerResult> => {
	try {
		const { errors } = await client.mutate({
			mutation: UPSERT_COMPANY,
			variables: { restaurantId, input },
			refetchQueries: ['CurrentUser'],
		})

		if (errors) {
			return { success: false, errors }
		}

		return { success: true, errors: null }
	} catch (e: unknown) {
		if (e && typeof e === 'object' && 'networkError' in e)
			return { success: false, errors: 'NETWORK_ERROR' }
		throw e
	}
}

export default upsertCompany
